var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 508.096 508.096",
    style: {
      enableBackground: "new 0 0 508.096 508.096"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F3F3"
    },
    d: "M111.368,142.656V286.64h285.328V142.656C396.696,64,332.696,0,254.024,0S111.368,64,111.368,142.656 z M135.368,142.656c0-65.536,53.12-118.672,118.656-118.672S372.68,77.12,372.68,142.656V262.64H135.368V142.656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E5E5"
    },
    d: "M135.368,142.656V262.64h237.328V142.656c0-65.536-53.12-118.672-118.656-118.672 S135.368,77.12,135.368,142.656z M159.368,142.656C159.368,90.464,201.832,48,254.04,48s94.672,42.464,94.672,94.656v95.984H159.368 V142.656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCC5B"
    },
    d: "M94.808,508.096h318.48c17.664,0,32-14.32,32-32v-231.28c0-17.664-14.336-32-32-32H94.808 c-17.68,0-32,14.336-32,32v231.28C62.808,493.776,77.128,508.096,94.808,508.096z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDBC4B"
    },
    d: "M309.752,380.928h12.112c10.272,0,18.592-8.368,18.528-18.64v-1.28v-0.272 c0.064-10.816-8.736-19.664-19.536-19.664h-15.664c-11.968,0-22.704-8.96-23.328-20.912c-0.672-12.752,9.472-23.296,22.08-23.296 h56.512c10.688,0,18.656-8.976,18.528-19.664c0-0.08,0-0.176,0-0.272s0-0.176,0-0.272c0.128-10.688-7.84-19.648-18.528-19.648 h-18.272c-11.968,0-22.704-8.96-23.328-20.912c-0.672-12.752,9.472-23.296,22.08-23.296h72.352c17.664,0,32,14.32,32,32v231.28 c0,17.68-14.336,32-32,32h-93.712c-12.208,0-22.112-9.904-22.112-22.112s9.904-22.112,22.112-22.112h29.568 c10.224,0,18.544-8.368,18.496-18.592v-0.24c0-0.448,0.016-0.896,0.048-1.344c0.608-10.08-7.392-18.576-17.488-18.576H311 c-11.968,0-22.704-8.96-23.328-20.912C287.016,391.472,297.16,380.928,309.752,380.928z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464646"
    },
    d: "M205.96,333.2c0-26.56,21.536-48.08,48.08-48.08c26.56,0,48.08,21.536,48.08,48.08 c0,17.728-9.712,33.056-24,41.392l6.592,61.2h-61.36l6.592-61.2C215.656,366.256,205.96,350.944,205.96,333.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD769"
    },
    d: "M111.368,331.6c8.832,0,16,7.152,16,16v92.064c0,8.848-7.168,16-16,16s-16-7.152-16-16V347.6 C95.368,338.768,102.536,331.6,111.368,331.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD769"
    },
    d: "M111.368,265.248c8.832,0,16,7.152,16,16v18.736c0,8.848-7.168,16-16,16s-16-7.152-16-16v-18.736 C95.368,272.4,102.536,265.248,111.368,265.248z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.c0157a94158dd1e9f00ae1d6ff149f92.svg";
export { ForwardRef as ReactComponent };